<template>
  <div class="step" :style="$style(buttonStyle)" @click="goStep(step)" :isStep="isStep">
    <div class="step-content" :style="!isStep ? $style(style.content) + ($screen.width > 768 ? $style(style.content_pc) : '') : ''">
      <div class="step-icon"><iconic :name="icon" /></div>
      <div class="step-label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
import UserVerifyMisc from "../user/UserVerifyMisc.js";
export default {
  mixins: [UserVerifyMisc],
  props: ["step", "num", "label", "icon"],
};
</script>

<style lang="scss" scoped>
.step {
  &-icon {
    font-size: 150%;
    margin: 0 0 $mpadding/6 0;
  }
  &[isStep="true"] {
    &::after,
    &::before {
      content: "";
      display: inline-block;
      display: inline-block;
      width: 40px;
      height: 40px;
      position: absolute;
      top: calc(100% + #{$mpadding}/ 1.2);
      z-index: -1;
      transform: rotate(135deg);
      border-radius: $mpadding/4;
    }
    &::before {
      box-shadow: $dshadow;
    }
    &::after {
      background-image: linear-gradient(to right top, #ffffff, #ffffff, #ffffff, rgb(255, 255, 255), #ffffff);
      z-index: 1;
    }
  }
  @include screen_tablet() {
    position: relative;
  }
  @include screen_desktop() {
    &-icon {
      font-size: 170%;
    }
  }
}
</style>
